import VueRouter from 'vue-router'
import { routes } from './routes'



const scrollBehavior = function (to, from, savedPosition) {
  return new Promise(resolve => {
    if (savedPosition) {
      resolve(savedPosition)
    } else {
      if (to.hash && document.querySelector(to.hash)) {
        const position = { selector: to.hash, offset: { y: 50 } }
        resolve(position)
      } else {
        resolve({ x: 0, y: 0 })
      }
    }
  })
}

export const router = new VueRouter({
  mode: 'history',
  scrollBehavior,
  base: process.env.BASE_URL,
  routes
})